import { AbstractControl} from "@angular/forms";

export class Validacoes {

    static ValidaCpf(controle: AbstractControl) {

        const campo = controle.value;

        let cpf : string;
        let numeros : any;
        let digitos : any;
        let soma : any;
        let i : number;
        let resultado : any;
        let digitos_iguais : any;
        let valido: boolean;

        cpf = campo.replace(/\.{1}/g, '');
        cpf = cpf.replace(/\-{1}/g, '');

        if (cpf.length == 11)  {

            digitos_iguais = 1;

            for (i = 0; i < cpf.length - 1; i++)
                if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                    digitos_iguais = 0;
                    break;
                }

            if (!digitos_iguais) {

                digitos = cpf.substring(9);

                numeros = cpf.substring(0, 9);
                soma = 0;
                for (i = 10; i > 1; i--)
                    soma += numeros.charAt(10 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != parseInt(digitos.charAt(0))){
                    valido = false;
                }

                numeros = cpf.substring(0, 10);
                soma = 0;
                for (i = 11; i > 1; i--)
                    soma += numeros.charAt(11 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

                if (resultado != parseInt(digitos.charAt(1))){
                    valido = false;
                }else{
                    valido = true;
                }

            }else{
                valido = false;
            }

        } else {
            valido = false;
        }

        if (valido) return null;

        return { cpfInvalido: true };

    }

    static NumeroInscricao(controle: AbstractControl) {

        const campo = controle.value;
        let numInscriao : string;
        let valido :boolean = false;

        numInscriao = campo.replace(/\D/g);
        if (numInscriao.length == 7 || numInscriao.length == 0)  {
            valido=true;
        }

        if(valido){
            return null;
        }else{
            return { NumeroInscricaoInvalido: true };
        }
    }

    static numeroTelefone(telefone: string): any {
        if (telefone) {
          const value = telefone.toString().replace(/\D/g, '');
    
          let foneFormatado = '';
    
          if (value.length > 12) {
            foneFormatado = value.replace(/(\d{2})?(\d{2})?(\d{5})?(\d{4})/, '+$1($2)$3-$4');
    
          } else if (value.length > 11) {
            foneFormatado = value.replace(/(\d{2})?(\d{2})?(\d{4})?(\d{4})/, '+$1($2)$3-$4');
    
          } else if (value.length > 10) {
            foneFormatado = value.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1)$2-$3');
    
          } else if (value.length > 9) {
            foneFormatado = value.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1)$2-$3');
    
          } else if (value.length > 5) {
            foneFormatado = value.replace(/^(\d{2})?(\d{4})?(\d{0,4})/, '($1)$2-$3');
    
          } else if (value.length > 1) {
            foneFormatado = value.replace(/^(\d{2})?(\d{0,5})/, '($1) $2');
          } else {
            if (telefone !== '') { foneFormatado = value.replace(/^(\d*)/, '($1'); }
          }
          return foneFormatado;
        }
      }

    
}

